import { atom } from 'recoil';

export const cashOutCbuCvu = atom({
  key: 'cashOutCbuCvu',
  default: undefined,
});
